import { z } from 'zod'
import { parseRequestError } from '@/common/utilities.ts'
import axios from 'axios'

const CountryObjectSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  code: z.string().nullable(),
})

const CountryListSchema = z.object({
  data: z.array(CountryObjectSchema),
})
export type CoutryList = z.infer<typeof CountryListSchema>

export const GetCountryList = async (): Promise<CoutryList> => {
  try {
    const response = await axios.get(`countries`)
    return CountryListSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

const StateObjectSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  code: z.string().nullable(),
})
const StateListSchema = z.object({
  data: z.array(StateObjectSchema),
})
export type StateList = z.infer<typeof StateListSchema>

export const GetStateByContryId = async (
  countryId?: number
): Promise<StateList> => {
  try {
    const response = await axios.get(`states?global_country_id=${countryId}`)
    return StateListSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

const TimeZoneObjectSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  code: z.string().nullable(),
})
const TimeZoneListSchema = z.object({
  data: z.array(TimeZoneObjectSchema),
})
export type TimeZoneList = z.infer<typeof TimeZoneListSchema>

export const GetTimeZoneList = async (): Promise<TimeZoneList> => {
  try {
    const response = await axios.get(`timezones`)
    return StateListSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}
